export enum NLogLevel {
    Trace = 1,
    Debug,
    Info,
    Warn,
    Error,
    Fatal
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/enums/nlog-level.ts